export const getFirstName = (fullName: string) => fullName.split(' ')[0];
